<template>
	<div class="d-flex flex-column justify-content-center mt-2">    	
    	<div class="_block align-self-center">
			<canvas ref="gameCanvas" class="_canvas" v-show="loaded"></canvas>
			<div v-if="!loaded" class="_loader d-flex  flex-column justify-content-center">
				<img class="_logo align-self-center" src="/img/logo.png" alt="">				
				<div class="_progress_bar_empty align-self-center">
					<div ref="progressBar"></div>
				</div>								
			</div>
		</div>
		<div class="align-self-center mt-3" v-if="loaded"> 
			<button class="btn btn-sm btn-secondary" @click="fullScreen()">Full screen</button>
		</div>
    </div>	
</template>

<script setup>

import { http } from '@/helpers/http'
import { onMounted, onUnmounted, ref, inject } from 'vue';
import $swal from '@/helpers/swal'
import { useWeb3Modal } from '@web3modal/ethers5/vue'
import { useWeb3ModalAccount, useWeb3ModalProvider } from '@web3modal/ethers5/vue'
import { ethers } from 'ethers'


const { address, isConnected } = useWeb3ModalAccount()  
const modal = useWeb3Modal()

const loaded = ref(null)
const unityInstance = ref(null)
const $mitt = inject('$mitt')

const gameCanvas = ref(null)
const progressBar = ref(null)

const connectAccount = async () => {
	if (!address.value) return modal.open()
	if (address.value) {
		try {					
			const uidResp = await http.get(`auth/get-uid?address=${address.value}`)
			const uid = uidResp.data.uid

			const { walletProvider } = useWeb3ModalProvider()
			console.log('walletProvider', walletProvider.value)

			const provider = new ethers.providers.Web3Provider(walletProvider.value);

			const signature = await provider.getSigner().signMessage("Sign this message to log in \n" + uid)
			const signResp = await http.post(`auth/sign-uid`, { uid, signature })
			if (signResp.data.uid === uid) {
				//window.web3gl.networkId = this.$bc.chainId
				window.web3gl.connectAccount = address.value
				window.web3gl.authUid = uid
			} else {
				window.web3gl.authUid = null
				window.web3gl.connectAccount = null
			}	
		} catch (error) {
			console.log('connectAccount', error)					
		}
	} else {
		window.web3gl.authUid = null
		window.web3gl.connectAccount = null
	}
}
		
const signMessage = async (message) => {
	try {
		const signature = await this.$bc.account.getSigner().signMessage(message)
		window.web3gl.signMessageResponse = signature;
	} catch (error) {
		window.web3gl.signMessageResponse = error.message;
	}
}

onMounted(() => {
	window.web3gl = {
		serverUrl:  'wss://game.dashleague.io/socket',
		authUid: '',
		networkId: 43114,
		connect: connectAccount,
		connectAccount: "",
		signMessage: signMessage,
		signMessageResponse: "",
		sendTransaction: () => {},
		sendTransactionResponse: "",
		sendContract: () => {},
		sendContractResponse: "",
	}

	function unityShowBanner(msg, type) {
		$swal({
			icon: "error",
			title: type.toUpperCase(),
			text: msg,
		});					
	}
	
	var loaderUrl =  "/loader/"
	var webglUrl =  "/webgl/"
	var version = '0.4.34'
			
	var config = {
		loaderUrl: loaderUrl + `${version}.loader.js`,
		frameworkUrl: loaderUrl + `${version}.framework.js`,
		dataUrl: webglUrl + `${version}.data`,
		codeUrl: webglUrl + `${version}.wasm`,
		symbolsUrl: webglUrl + `${version}.symbols.json`,
		streamingAssetsUrl: "StreamingAssets",
		companyName: "Sysware Games",
		productName: "DashLeagueGame",
		productVersion: version,
		showBanner: unityShowBanner,
	};

	if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {			
		config.devicePixelRatio = 1;
		unityShowBanner('WebGL builds are not supported on mobile devices.');
	} 
	
	try {
		var script = document.createElement("script");
		script.src = config.loaderUrl;
		script.onload = () => {
			createUnityInstance(gameCanvas.value, config, (progress) => {
				progressBar.value.style.width = 100 * progress + "%";
			}).then((unityInst) => {
				unityInstance.value = unityInst
				loaded.value = true
			}).catch((message) => {
				alert(message);
			});
		};
		document.body.appendChild(script);
	} catch (error) {
		console.log('unityInstance', error)
	}	
})

const fullScreen = () => {
	if (unityInstance.value) {
		unityInstance.value.SetFullscreen(1);
	}			
}

</script>

<style lang="scss" scoped>
    @import "@/scss/variables";
	._block {
		background: rgb(73 59 57);
		border: 3px solid #313949;
		border-radius: 1rem;
		outline: 5px solid #7b8291;
		position: relative;
		height: calc(100% - 40px);
		box-shadow: 0rem 0.5rem 0.3rem rgb(0 0 0 / 70%);
		padding: 0;
		margin: 0;
		width: 100%;
		overflow: hidden;
		._canvas {
			background-color: $_block_bg_color;
			width: 100%;
		}
		._loader {
			background-color: $_block_bg_color;
			height: 600px;
			._logo {
				width: 300px;
			}
			._progress_bar_empty {
				width: 141px; 
				height: 18px; 
				background: url('/public/img/progress-bar-empty-light.png') no-repeat center;
				div {
					width: 0%; 
					height: 18px; 
					background: url('/public/img/progress-bar-full-light.png') no-repeat center;
				}
			}
		}
	}    
</style>
























